module.exports = __webpack_public_path__ + "static/media/gf_1.9b89c2cd.jpg";